/* PARFUMPROBEN VERSAND – FAQ (sections/ppv-faq.liquid).
   Immer nur eine Kategorie offen. Suche über Frage + Antwort: Kategorien mit Treffern öffnen sich, ohne Treffer werden sie ausgeblendet.
   Geschlossene Antworten tragen hidden="until-found" – die Browsersuche (Strg+F) öffnet die passende Kategorie. */
(() => {
  if (window.__PPV_FAQ__) return;
  window.__PPV_FAQ__ = true;

  const normalize = value => String(value || '').toLocaleLowerCase('de').normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/\s+/g, ' ').trim();

  function init(section) {
    const search = section.querySelector('[data-ppv-faq-search]');
    const empty = section.querySelector('[data-ppv-faq-empty]');
    const cats = [...section.querySelectorAll('[data-ppv-faq-cat]')].map(cat => ({
      cat,
      button: cat.querySelector('[data-ppv-faq-toggle]'),
      body: cat.querySelector('[data-ppv-faq-body]'),
      items: [...cat.querySelectorAll('[data-ppv-faq-item]')].map(item => ({ item, text: normalize(item.textContent) }))
    }));
    let current = cats.find(entry => entry.cat.classList.contains('is-open')) || null;

    const setOpen = (entry, open) => {
      entry.cat.classList.toggle('is-open', open);
      entry.button.setAttribute('aria-expanded', String(open));
      if (open) entry.body.removeAttribute('hidden');
      else entry.body.setAttribute('hidden', 'until-found');
    };

    const showOnly = target => {
      cats.forEach(entry => setOpen(entry, entry === target));
      current = target;
    };

    function resetFilter() {
      cats.forEach(entry => {
        entry.cat.hidden = false;
        entry.items.forEach(({ item }) => { item.hidden = false; });
      });
      if (empty) empty.hidden = true;
    }

    function filter() {
      const term = normalize(search.value);
      if (!term) {
        resetFilter();
        showOnly(current);
        return;
      }
      let hits = 0;
      cats.forEach(entry => {
        let count = 0;
        entry.items.forEach(({ item, text }) => {
          const match = text.includes(term);
          item.hidden = !match;
          if (match) count += 1;
        });
        entry.cat.hidden = count === 0;
        setOpen(entry, count > 0);
        hits += count;
      });
      if (empty) empty.hidden = hits !== 0;
    }

    cats.forEach(entry => {
      entry.button.addEventListener('click', () => {
        const wasOpen = entry.cat.classList.contains('is-open');
        if (search && search.value) {
          search.value = '';
          resetFilter();
        }
        showOnly(wasOpen ? null : entry);
      });
      /* Browsersuche hat einen Treffer in einer geschlossenen Kategorie gefunden */
      entry.body.addEventListener('beforematch', () => {
        if (search && search.value) {
          search.value = '';
          resetFilter();
        }
        showOnly(entry);
      });
    });

    search?.addEventListener('input', filter);
    search?.addEventListener('keydown', event => {
      if (event.key === 'Escape' && search.value) {
        event.preventDefault();
        search.value = '';
        filter();
      }
    });
  }

  const start = () => document.querySelectorAll('[data-ppv-faq]').forEach(section => {
    if (section.dataset.ppvReady) return;
    section.dataset.ppvReady = 'true';
    init(section);
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('shopify:section:load', start);
})();
